import { z } from 'zod'

import { ensureRouteData, prefetchRouteData } from '@/app/query-client'
import {
  indexSymbolsQueryOptions,
  liveRunsQueryOptions,
  liveSignalsQueryOptions,
} from '@/features/signals/api/queries'
import type { RouterContext } from '@/routes/layouts/root'
import { liveRunParamSchema, sideParamSchema } from '@/screens/signals/search'

/**
 * `run` picks which run's picture to read; `side` picks the board
 * on the client and never change the read.
 */
export const liveSignalsSearchSchema = z.object({
  run: liveRunParamSchema,
  side: sideParamSchema,
})

/**
 * The `/market/signals/live` loader. MAIN: the board for the entry URL's run
 * (all runs when there is none), which the screen reads with `keepPreviousData`
 * and, for all runs, polls while NEPSE trades (`useLiveSignals`). SECONDARY:
 * the index symbols (which rows link) and the run list (the picker).
 */
export async function loadLiveSignals({
  context: { queryClient },
  location,
  preload,
}: {
  context: RouterContext
  location: { search: unknown }
  preload: boolean
}): Promise<void> {
  const { run } = liveSignalsSearchSchema.parse(location.search)
  if (!preload) {
    prefetchRouteData(queryClient, indexSymbolsQueryOptions())
    prefetchRouteData(queryClient, liveRunsQueryOptions())
  }
  await ensureRouteData(queryClient, liveSignalsQueryOptions(run ?? null))
}
